import { USER_UPDATED } from './auth'
import { SITE_ADMIN_PENDING_BOOKINGS_UPDATED } from './site_admin'

export const BOOKING_NOTIFICATION_DECISION_CHANGED = 'BOOKING_NOTIFICATION_DECISION_CHANGED'
export const bookingNotificationDecisionChanged = (booking, decision) => ({
    type: BOOKING_NOTIFICATION_DECISION_CHANGED,
    bookingId: booking.id,
    siteId: booking.siteId,
    decision,
})

export const CHANGE_DAYS_OFFSET = 'CHANGE_DAYS_OFFSET'
export const changeDaysOffset = daysOffset => ({
    type: CHANGE_DAYS_OFFSET,
    daysOffset,
})

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const changeLanguage = language => ({
    type: CHANGE_LANGUAGE,
    language,
})

export const NEW_VERSION_AVAILABLE = 'NEW_VERSION_AVAILABLE'
export const newVersionAvailable = (value = true) => ({
    type: NEW_VERSION_AVAILABLE,
    value
})


export const REFRESH_ALL = 'REFRESH_ALL'
export const refreshAll = (heartbeat = Date.now()) => ({
    type: REFRESH_ALL,
    heartbeat,
})

export const CHANGE_LOCATION = 'CHANGE_LOCATION'
export const changeLocation = (country, city) => ({
    type: CHANGE_LOCATION,
    country,
    city,
})
export const AUTODETECT_LOCATION = 'AUTODETECT_LOCATION'
export const autodetectLocation = () => ({
    type: AUTODETECT_LOCATION,
})

export const APPLY_SITE_ID = 'APPLY_SITE_ID'
export const applySiteId = siteId => ({
    type: APPLY_SITE_ID,
    siteId,
})
export const APPLY_ADMIN_SITE_ID = 'APPLY_ADMIN_SITE_ID'
export const applyAdminSiteId = siteId => ({
    type: APPLY_ADMIN_SITE_ID,
    siteId,
})

// A handover from client-web2 (`?auth-token=`) is signing in. It ends when
// the signed-in user arrives, or when the sign-in fails.
export const TOKEN_SIGN_IN = 'TOKEN_SIGN_IN'
export const tokenSignIn = pending => ({
    type: TOKEN_SIGN_IN,
    pending,
})

export const SET_VARIANT = 'SET_VARIANT'
export const setVariant = variant => ({
    type: SET_VARIANT,
    variant,
})

const defaultState = {
    daysOffset: 0,
    language: 'en',
    newVersionAvailable: false,
    heartbeat: 0,
    //TODO move to separate reducer - loader, maybe in place of sites
    country: null,
    city: null,
    applySiteId: null,
    applyAdminSiteId: null,
    variant: null,
    tokenSignInPending: false,
    bookingDecisions: {},
}

export const reducerUI = (state = defaultState, action) => {
    switch (action.type) {
        case BOOKING_NOTIFICATION_DECISION_CHANGED: {
            const starting = action.decision === 'accepting' || action.decision === 'rejecting'
            // A late response must not restore a guard already removed by the projection.
            if (!starting && !state.bookingDecisions?.[action.bookingId]) return state
            return { ...state, bookingDecisions: { ...state.bookingDecisions,
                [action.bookingId]: { siteId: action.siteId, decision: action.decision },
            } }
        }
        case SITE_ADMIN_PENDING_BOOKINGS_UPDATED: {
            // Decisions survive club switching until their own projection catches up.
            // Use the subscription's club, not the currently selected UI club.
            return { ...state, bookingDecisions: Object.fromEntries(Object.entries(state.bookingDecisions || {})
                .filter(([id, entry]) => entry.siteId !== action.siteId
                    || action.bookings.some(booking => booking.id === id))),
            }
        }
        case CHANGE_DAYS_OFFSET: {
            const { daysOffset } = action
            return { ...state, daysOffset }
        }
        case CHANGE_LANGUAGE: {
            return {
                ...state,
                language: action.language,
            }
        }
        case NEW_VERSION_AVAILABLE: {
            return {
                ...state,
                newVersionAvailable: action.value,
            }
        }
        case REFRESH_ALL: {
            return {
                ...state,
                heartbeat: action.heartbeat,
            }
        }
        case CHANGE_LOCATION: {
            const { country, city } = action
            return {
                ...state,
                country,
                city,
            }
        }
        case APPLY_SITE_ID: {
            return {
                ...state,
                applySiteId: action.siteId,
            }
        }
        case APPLY_ADMIN_SITE_ID: {
            return {
                ...state,
                applyAdminSiteId: action.siteId,
            }
        }
        case TOKEN_SIGN_IN: {
            return {
                ...state,
                tokenSignInPending: action.pending,
            }
        }
        case USER_UPDATED: {
            return action.user ? { ...state, tokenSignInPending: false } : state
        }
        case SET_VARIANT: {
            return {
                ...state,
                variant: action.variant,
            }
        }
        default:
            return state
    }
}
